import React, { Component } from 'react';
import { Form, Alert, Modal } from 'antd';
import { Auth } from '../../../../services/api';
import FinalizeForm from './FinalizeForm';

const WrappedForm = Form.create()(FinalizeForm);

export default class Finalize extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            loading: false
        };

        this.authApi = new Auth(props);
    }

    finalize = (password) => {
        const query = new URLSearchParams(this.props.location.search);
        const data = {
            password: password,
            code: query.get('code'),
            email: query.get('email').replace(' ', '+')
        };

        this.setState({ loading: true });
        this.authApi.finalizeReset(data)
            .then(res => {
                Modal.success({
                    title: 'Ditt lösenord har blivit återställt',
                    content: 'Klicka på knappen nedan för att logga in.',
                    okText: 'Logga in',
                    onOk: () => this.props.history.push(`/auth/login?email=${data.email}`)
                })
            })
            .catch(err => {
                this.setState({ loading: false });
                if (err.response && err.response.status === 400) {
                    if (err.response.data.error === 'Expired') {
                        Modal.error({
                            title: 'Återställingstiden har gått ut',
                            content: 'Tiden som din återställningslänk är giltig har gått ut. Klicka nedan för att begära en ny.',
                            okText: 'Ny återställning',
                            onOk: () => this.props.history.push('/auth/reset')                          
                        });
                    }
                } else {
                    Modal.error({
                        title: 'Återställningen misslyckades',
                        content: 'Ett oväntat fel intreffade. Klcika på knappen nedan för att återställa igen.',
                        okText: 'Ny återställning',
                        onOk: () => this.props.history.push('/auth/reset')                          
                    });
                }
            });
    }

    render() {
        const { loading  } = this.state;
        return (
            <div>
                <Alert
                    style={{marginBottom: '20px'}}
                    message="Återställ lösenord"
                    description="Ange nytt lösenord nedan för att slutföra åtreställningen."
                    type="info"
                />
                <WrappedForm onSubmit={this.finalize} loading={loading} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/reset/Finalize.js